module.exports = __webpack_public_path__ + "img/EVillager64_ua.0a90bd9f.webp";